import { BatchEventsManager } from "@faire/web/common/batch-events/BatchEventsManager";
import { createRecordClientEventRequest } from "@faire/web/common/events/createRecordClientEventRequest";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
/**
 * Delegate for all generated PETE event utils, which handles the various schema configurations.
 */
export const trackClientEvent = (params) => {
    var _a;
    const { request, currentEventTime } = createRecordClientEventRequest(params);
    const eventRequest = request; // Sidestep circular dependency issue;
    BatchEventsManager.get().enqueueEvent(eventRequest);
    const trackedEvent = Object.assign(Object.assign({}, params), { eventId: eventRequest.event_id });
    (_a = getGlobalProperty("faire.events.interceptors")) === null || _a === void 0 ? void 0 : _a.forEach((i) => i(trackedEvent));
    return {
        sourceEventHash: eventRequest.source_event_hash,
        sourceEventKey: params.eventKey,
        sourceEventStart: currentEventTime,
    };
};
